import React from 'react'
import PropTypes from 'prop-types'

import CommonReport from 'component/commonReport/CommonReport'
import { getLines } from 'component/commonReport/Data'

class Teste extends React.Component {
  render() {
    const {
      auth: { user },
      translate,
    } = this.props

    const reportProperties = {
      title: 'Relatório de  uso e consumo',
      order: false,
      defaultOrder: 'request_date',
      onExport: (callback) => {
        setTimeout(() => {
          const opt = true
          callback(opt)
        }, 2500)
      },
      onSubmit: (body, callback) => {
        const data = getLines(20)
        setTimeout(() => {
          callback(data)
        }, 1000)
      },
      columns: {
        request_date: {
          label: 'Data',
          align: 'left',
          fixed: true,
        },
        store: {
          label: 'Loja',
          fixed: true,
          align: 'left',
        },
        region: {
          label: 'Região',
          fixed: true,
          align: 'left',
        },
        quantity: {
          label: 'Quantidade',
          fixed: true,
          align: 'left',
          checkNegative: true,
        },
        ammount: {
          label: 'Valor',
          fixed: true,
          checkNegative: true,
          align: 'center',
        },
        lm: {
          label: 'LM',
        },
        description: {
          label: 'Descrição',
        },
        description2: {
          label: 'Descrição',
        },
        section: {
          label: 'Seção',
        },
        requesting: {
          label: 'Montagem',
        },
      },
      fields: [
        {
          type: 'input',
          name: 'test',
          label: 'Teste',
          help_text: 'Teste',
          required: true,
          error_text: 'Preencha o campo',
        },
        {
          type: 'select',
          name: 'types1',
          label: 'Selecione o tipo',
          help_text: 'Selecione um tipo',
          attrs: {},
          options: [
            {
              value: 1,
              label: 'Tipo 01',
            },
            {
              value: 2,
              label: 'Tipo 02',
            },
            {
              value: 3,
              label: 'Tipo 03',
            },
            {
              value: 4,
              label: 'Tipo 04',
            },
          ],
        },
        {
          type: 'select_multiple',
          name: 'types2',
          label: 'Selecione o tipo',
          help_text: 'Selecione um tipo',
          attrs: {},
          options: [
            {
              value: 1,
              label: 'Tipo 01',
            },
            {
              value: 2,
              label: 'Tipo 02',
            },
            {
              value: 3,
              label: 'Tipo 03',
            },
            {
              value: 4,
              label: 'Tipo 04',
            },
          ],
        },
        {
          type: 'date_range',
          name: 'period',
          label: 'Período',
          help_text: 'Selecione o período',
          required: true,
        },
        {
          type: 'branchs',
          name: 'branchs',
          label: 'Lojas',
          help_text: 'Selecione uma loja',
          required: true,
          error_text: 'Selecione ao menos uma loja',
        },
        {
          type: 'sections',
          name: 'sections',
          label: 'Seção',
          help_text: 'Escolha uma seção',
        },
        {
          type: 'checkbox',
          name: 'no_storage',
          label: 'Sem estoque',
          initial: false,
        },
      ],
    }
    return (
      <CommonReport {...reportProperties} user={user} translate={translate} />
    )
  }
}

Teste.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Teste
export { Teste }
